module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-04-47f62755a7c6ac771a07be3b8ae0a7d4.webp";